import serviceType from "./serviceTypes";
const employee = [
  {
    serviceName: serviceType.USER_ROLE,
    text: "experts",
    to: "specialists",
    icon: "MedicalServices"
  },
  {
    serviceName: serviceType.DOCTOR,
    text: "doctor_educations",
    to: "doctor-educations",
    icon: "Class"
  },
  // Doktorlar sayfası pasif (görünmesin)
  // {
  //   serviceName: serviceType.DOCTOR,
  //   text: "doctors",
  //   to: "doctor",
  //   icon: "LocalHospital",
  // },
  {
    serviceName: serviceType.PATIENT,
    text: "patients",
    to: "patient",
    icon: "Person",
  },
  {
    serviceName: serviceType.EMPLOYEE,
    text: "employees",
    to: "employee",
    icon: "AccountCircle",
  },
  {
    serviceName: "", // Boş = yetki kontrolü yok, tüm employee görebilir (backend'de ASSISTANT yetkisi rolde olmayabilir)
    text: "assistants",
    to: "assistants",
    icon: "Assistant",
  },
  {
    serviceName: serviceType.USER_ROLE,
    text: "user_role",
    to: "user-role",
    icon: "SupervisedUserCircle",
  },
  {
    serviceName: serviceType.USER_ROLE,
    text: "languages",
    to: "/languages",
    icon: "Language",
  },
  {
    serviceName: serviceType.NOTIFICATION,
    text: "notification_messages",
    to: "notification-message",
    icon: "Notifications",
  },
  {
    serviceName: serviceType.NOTIFICATION_MESSAGE,
    text: "broadcast_notification",
    to: "broadcast-notification",
    icon: "Campaign",
  },
  {
    serviceName: serviceType.PRICING,
    text: "price",
    to: "price",
    icon: "CurrencyLira",
  },
  {
    serviceName: serviceType.TICKET_BUG_REPORT,
    text: "tickets",
    to: "tickets",
    icon: "BugReport"
  },
  {
    serviceName: serviceType.BOOKED_APPOINTMENT,
    text: "appointments",
    to: "appointment",
    icon: "Appointment"
  },
  /* TODO: Bu sayfalarla ne yapılacağı karar verilecek. */
  /*  {
     serviceName: serviceType.USER_ROLE,
     text: "hangfire-jobs",
     to: "hangfire-jobs",
     icon: "Monitor"
   },
   {
     serviceName: serviceType.USER_ROLE, //TODO serviceType.SKRS_OPERATIONS yaptığımızda görünmüyor?
     text: "skrs-operations",
     icon: "FactCheck",
     children: [
       {
         serviceName: serviceType.USER_ROLE,
         text: "skrs-list",
         to: "skrs-list",
         icon: "Emergency"
       },
     ]
   }
   ,
   {
     serviceName: serviceType.USER_ROLE, //TODO serviceType.USS_OPERATIONS yaptığımızda görünmüyor?
     text: "uss-operations",
     icon: "Assignment",
     children: [
       {
         serviceName: serviceType.USER_ROLE,
         text: "enabiz-blood-management",
         to: "enabiz-blood-management",
         icon: "Blood"
       },
     ]
   }, */
  {
    serviceName: serviceType.CATEGORY,
    text: "specialty_category_management",
    to: "specialty-category-management",
    icon: "MedicalServices"
  },
  {
    serviceName: serviceType.USER_ROLE,
    text: "audit_logs",
    to: "audit-logs",
    icon: "Visibility"
  },
  {
    serviceName: serviceType.SERVICE_PURCHASE,
    text: "service_purchases",
    to: "service-purchases",
    icon: "ShoppingCart"
  },
  {
    serviceName: serviceType.SERVICE_REFUND,
    text: "service_refund_requests",
    to: "service-refund-requests",
    icon: "AssignmentReturn"
  },
  {
    serviceName: serviceType.APP_VERSION_CONFIGURATION,
    text: "app_version_configuration",
    to: "app-version",
    icon: "Settings"
  }
];

const doctor = [
  {
    serviceName: serviceType.BOOKED_APPOINTMENT,
    text: "appointment_calendar",
    to: "appointments/calendar",
    icon: "Calendar",
  },
  {
    serviceName: serviceType.BOOKED_APPOINTMENT,
    text: "my_appointments",
    to: "appointments/list",
    icon: "CalendarMonthOutlinedIcon",
  },
  {
    serviceName: serviceType.PATIENT,
    text: "my_patients",
    to: "my-patients",
    icon: "Person"
  },
  /*  {
     serviceName: serviceType.ASSIGNED_TREATMENT,
     text: "treatment_demands",
     to: "treatment-demands",
     icon: "MonitorHeartIcon",
   }, */
  /* {
    serviceName: serviceType.TREATMENT_DEMAND,
    text: "demand_pool",
    to: "demand-pool",
    icon: "ListOutlinedIcon",
  }, */
  {
    serviceName: serviceType.MESSAGE_ROOM,
    text: "messages",
    to: "messages",
    icon: "Mail",
  },
  {
    serviceName: serviceType.NOTIFICATION,
    text: "notifications",
    to: "notifications",
    icon: "Notifications",
  },
  {
    serviceName: "",
    text: "assistants",
    to: "assistants",
    icon: "Assistant"
  },
  /*  {
     serviceName: serviceType.TREATMENT_DEMAND,
     text: "evaluated_treatments",
     to: "evaluated-treatments",
     icon: "EvaluatedTreatments"
   }, */
  {
    serviceName: serviceType.TREATMENT_DEMAND,
    text: 'notes',
    to: 'notes',
    icon: "Note"
  },
  {
    serviceName: serviceType.DOCTOR_TRIAGE,
    text: "triage",
    to: "triage",
    icon: "Triage"
  },
  {
    serviceName: "",
    text: "service_fees",
    to: "service-package",
    icon: "Money"
  },
  {
    serviceName: "",
    text: "service_purchases",
    to: "service-purchase",
    icon: "Chart"
  },
  {
    serviceName: "",
    text: "invoice_operations",
    to: "invoice-operations",
    icon: "ReceiptIcon"
  },
  {
    serviceName: serviceType.TICKET_BUG_REPORT,
    text: "technical_support",
    to: "tickets",
    icon: "HeadSet"
  }
];

const patient = [
  {
    serviceName: serviceType.DOCTOR,
    text: "doctors",
    to: "doctors",
    icon: "LocalHospital",
  },
  {
    serviceName: "",
    text: "appointments",
    to: "appointments",
    icon: "CalendarMonthOutlinedIcon"
  },
  {
    serviceName: "",
    text: "contact",
    to: "tickets",
    icon: "Contact"
  }
];

const assistant = [
  {
    serviceName: serviceType.BOOKED_APPOINTMENT,
    text: "appointment_calendar",
    to: "doctor/appointments/calendar",
    icon: "Calendar",
  },
  {
    serviceName: "",
    text: "patients",
    to: "doctor/patients",
    icon: "Person",
  },
  {
    serviceName: serviceType.MESSAGE_ROOM,
    text: "messages",
    to: "messages",
    icon: "Mail",
  },
  {
    serviceName: serviceType.TICKET_BUG_REPORT,
    text: "help_and_support",
    to: "tickets",
    icon: "HeadSet",
  },
  {
    serviceName: "",
    text: "settings",
    to: "settings",
    icon: "Settings",
  },
];

const menuList = { employee, doctor, patient, assistant };

export default menuList;